import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const artistFilterCriteria = (isMobileVersion, styles, isChartsMode) => {
  return isChartsMode
    ? [
        {
          title: "Location",
          isHide: isMobileVersion,
          isLocation: true,
        },
        {
          icon: Images.iconCalendarColored,
          width: 20,
          height: 20,
          title: "Date",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 1,
              label: moment().subtract(1, "year").format("YYYY"),
              tagId: moment().subtract(1, "year").format("YYYY"),
            },
            {
              id: 2,
              label: moment().format("YYYY"),
              tagId: moment().format("YYYY"),
            },
            {
              id: 3,
              label: moment().add(1, "year").format("YYYY"),
              tagId: moment().add(1, "year").format("YYYY"),
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_MUSIC,
          icon: Images.iconTagMusic,
          width: 20,
          height: 20,
          title: "Music",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 0,
              label: "All",
              tagId: 300,
            },
            {
              id: 1,
              label: "Electronic",
              tagId: 301,
            },
            {
              id: 2,
              label: "Pop",
              tagId: 302,
            },
            {
              id: 3,
              label: "Rock",
              tagId: 303,
            },
            {
              id: 4,
              label: "Hip-Hop",
              tagId: 304,
            },
            {
              id: 5,
              label: "R&B",
              tagId: 305,
            },
            {
              id: 6,
              label: "Reggae",
              tagId: 306,
            },
            {
              id: 7,
              label: "Jazz",
              tagId: 307,
            },
            {
              id: 8,
              label: "Blues",
              tagId: 308,
            },
            {
              id: 9,
              label: "Metal",
              tagId: 309,
            },
            {
              id: 10,
              label: "Punk",
              tagId: 310,
            },
            {
              id: 11,
              label: "Country",
              tagId: 311,
            },
            {
              id: 12,
              label: "Folk",
              tagId: 312,
            },
            {
              id: 13,
              label: "Latin",
              tagId: 313,
            },
            {
              id: 14,
              label: "Classical",
              tagId: 314,
            },
            {
              id: 15,
              label: "Religious",
              tagId: 315,
            },
          ],
          selectedList: [],
        },
        {
          icon: Images.iconTagEventType,
          width: 20,
          height: 20,
          title: "Category",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 1,
              label: "Acts",
              tagId: Constants.sortByAction.SORT_BY_EVENT_COUNT,
            },
            {
              id: 2,
              label: "Popularity",
              tagId: Constants.sortByAction.SORT_BY_EVENT_POPULARITY,
            },
          ],
          selectedList: [],
        },
      ]
    : [
        {
          id: Constants.tagCategory.TAG_CATEGORY_MUSIC,
          icon: Images.iconTagMusic,
          width: 20,
          height: 20,
          title: "Music",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Electronic",
              tagId: 301,
            },
            {
              id: 2,
              label: "Pop",
              tagId: 302,
            },
            {
              id: 3,
              label: "Rock",
              tagId: 303,
            },
            {
              id: 4,
              label: "Hip-Hop",
              tagId: 304,
            },
            {
              id: 5,
              label: "R&B",
              tagId: 305,
            },
            {
              id: 6,
              label: "Reggae",
              tagId: 306,
            },
            {
              id: 7,
              label: "Jazz",
              tagId: 307,
            },
            {
              id: 8,
              label: "Blues",
              tagId: 308,
            },
            {
              id: 9,
              label: "Metal",
              tagId: 309,
            },
            {
              id: 10,
              label: "Punk",
              tagId: 310,
            },
            {
              id: 11,
              label: "Country",
              tagId: 311,
            },
            {
              id: 12,
              label: "Folk",
              tagId: 312,
            },
            {
              id: 13,
              label: "Latin",
              tagId: 313,
            },
            {
              id: 14,
              label: "Classical",
              tagId: 314,
            },
            {
              id: 15,
              label: "Religious",
              tagId: 315,
            },
          ],
          selectedList: [],
        },
        // {
        //   isLocation: true,
        //   icon: Images.iconTagCountry,
        //   width: 16,
        //   height: 19.5,
        //   title: "Country",
        //   isHide: false,
        //   isSearchable: true,
        //   isCountry: true,
        //   detailList: [
        //     // from api country
        //   ],
        //   selectedList: [],
        // },
        {
          isActivity: true,
          icon: Images.iconTagActivity,
          width: 18,
          height: isMobileVersion ? 20 : 22,
          title: "Activity",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "On Tour",
            },
            {
              id: 2,
              label: "Inactive",
            },
          ],
          selectedList: [],
        },
        {
          icon: Images.iconSearchEvent,
          width: 20,
          height: 20,
          title: "Events",
          isHide: false,
          isEventSize: true,
          detailList: [
            {
              id: 1,
              label: "0",
              value: { value: 0 },
            },
            {
              id: 2,
              label: "1-4",
              value: { minValue: 1, maxValue: 4 },
            },
            {
              id: 3,
              label: "5-9",
              value: { minValue: 5, maxValue: 9 },
            },
            {
              id: 4,
              label: "10-19",
              value: { minValue: 10, maxValue: 19 },
            },
            {
              id: 5,
              label: "20-49",
              value: { minValue: 20, maxValue: 49 },
            },
            {
              id: 6,
              label: "+50",
              value: { minValue: 50 },
            },
          ],
          selectedList: [],
        },
        {
          title: "Location",
          isHide: isMobileVersion,
          isLocation: true,
        },
        {
          icon: Images.iconCalendarColored,
          width: 20,
          height: 20,
          title: "Date",
          isHide: false,
          // isHide: !isSearch,
          isDate: true,
          dateType: "anytime",
        },
      ];
};
